export default __webpack_public_path__ + "static/media/indesign.1efe97b6.png";